/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareBracketRight: {
  name: 'square-bracket-right';
  data: string;
} = {
  name: 'square-bracket-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="1" width="14" height="14" rx="1"/><path d="M7 4s2 1.333 2 4-2 4-2 4"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
